import { Box } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { useTheme } from '@mui/system';
import * as Preact from 'preact';
import * as H from 'preact/hooks';
import * as ConfigRenderAlert from '../A_RenderAlert';
import * as ActionBarConfigure from '../M_ActionBarConfigure';
import * as ActionBarExplore from '../M_ActionBarExplore';
import * as ActionBarUndoRedo from '../M_ActionBarUndoRedo';
import * as BrendaCanvas from '../M_BrendaCanvas';
import * as LoadingWithText from '../O_LoadingWithText';
import * as RenderError from '../O_RenderError';
import { isSmallScreen } from '../domain/theme/breakpoints';
import { useTranslations } from '../utils/TranslationsWrapper';
export var productDrawerWidth = '433px';
export var Component = function (p) {
    var t = useTranslations().t;
    var isSmall = isSmallScreen(useTheme());
    var _a = useShowRenderError(p.renderError, isSmall, p.configurePanelOpen, p.inConfiguration), showRenderAlert = _a.showRenderAlert, showRenderErrorModal = _a.showRenderErrorModal, closeAlert = _a.closeAlert;
    // Doesnt display configure button for spheres etc which is no longer valid, review this function!!
    var onConfigurePanelToggle = p.showSceneConfigure
        ? function () {
            p.onConfigurePanelToggle(!p.configurePanelOpen);
        }
        : undefined;
    return (Preact.h(Box, { sx: {
            display: 'grid',
            // using gap and background color to achieve a 1px 'border' between grid elements
            gridGap: '1px',
            background: '#ECECEC',
            gridTemplateAreas: "'configure-panel scene'",
            gridTemplateRows: '100%',
            gridTemplateColumns: !isSmall && p.configurePanelOpen
                ? "".concat(productDrawerWidth, " calc(100% - ").concat(productDrawerWidth, ") ")
                : '0px 100%',
            height: '100%',
            width: '100%',
        } },
        (p.configurePanelOpen || (isSmall && p.proposalLoading)) && (Preact.h(Box, { sx: {
                height: '100%',
                width: { xs: '100%', md: productDrawerWidth },
                position: { xs: 'absolute', md: 'relative' },
                top: { xs: '0px', md: 'unset' },
                zIndex: 'drawer',
                gridArea: 'configure-panel',
            }, "data-testid": "configure-panel" }, p.proposalLoading ? (Preact.h(LoadingWithText.Component, { loadingText: t('loading.compatibility') })) : (p.drawerContent))),
        Preact.h(Box, { id: "three-d-content (brenda)", sx: {
                position: 'relative',
                height: '100%',
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                gridArea: 'scene',
            } },
            p.sceneLoading ? (Preact.h(Box, { sx: { position: 'absolute', top: '50%', width: '20%' } },
                Preact.h(LinearProgress, null))) : null,
            showRenderErrorModal && (Preact.h(RenderError.Component, { openConfigurePanel: isSmall
                    ? function () {
                        p.onConfigurePanelToggle(true);
                    }
                    : undefined })),
            Preact.h(ConfigRenderAlert.Component, { show: showRenderAlert, close: closeAlert }),
            Preact.h(BrendaCanvas.Component, { onReady: p.onRendererReady, options: p.rendererOptions }),
            !p.configurePanelOpen && (Preact.h(ActionBarConfigure.Component, { configToggleText: p.configPanelButtonText, configSelected: p.configurePanelOpen, onConfigToggle: onConfigurePanelToggle, sx: isSmall
                    ? {
                        bottom: '20px',
                        right: '20px',
                    }
                    : {
                        bottom: '20px',
                        left: '20px',
                    } })),
            Preact.h(ActionBarExplore.Component, { onDimensionsToggle: p.onDimensionsToggle, showDimensions: p.showDimensions, sx: isSmall
                    ? {
                        bottom: '20px',
                        left: '20px',
                    }
                    : {
                        bottom: '20px',
                    } }),
            p.showUndoRedo && (Preact.h(ActionBarUndoRedo.Component, { onUndoClick: p.canUndo ? p.onUndoClick : undefined, onRedoClick: p.canRedo ? p.onRedoClick : undefined, sx: isSmall
                    ? {
                        bottom: '74px',
                        left: '20px',
                    }
                    : {
                        bottom: '20px',
                        right: '20px',
                    } })))));
};
export var useShowRenderError = function (error, isSmallScreen, isConfigPanelOpen, inConfiguration) {
    var _a = H.useState(false), showRenderErrorModal = _a[0], setShowRenderErrorModal = _a[1];
    var _b = H.useState(false), showRenderAlert = _b[0], setShowRenderAlert = _b[1];
    H.useEffect(function () {
        if (isSmallScreen && error && !isConfigPanelOpen && !inConfiguration) {
            // Conspiration on mobile when the panel is closed
            setShowRenderErrorModal(true);
        }
        else if (!isSmallScreen && error && !inConfiguration) {
            // Conspiration on desktop
            setShowRenderErrorModal(true);
        }
        else if (isSmallScreen && error && !isConfigPanelOpen && inConfiguration) {
            // Configuration on mobile when the panel is closed
            setShowRenderAlert(true);
        }
        else if (!isSmallScreen && error && inConfiguration) {
            // Configuration on desktop
            setShowRenderAlert(true);
        }
        else if (!inConfiguration) {
            // Removed parts and back in Conspiration
            setShowRenderAlert(false);
            setShowRenderErrorModal(false);
        }
        else
            setShowRenderErrorModal(false);
    }, [isSmallScreen, error, isConfigPanelOpen, inConfiguration]);
    var closeAlert = function () { return setShowRenderAlert(false); };
    return { showRenderAlert: showRenderAlert, showRenderErrorModal: showRenderErrorModal, closeAlert: closeAlert };
};
Component.displayName = '3DScene';
